import React, { useEffect, useRef } from 'react';
import ContainerProps from './Container.types';
import styles from './Container.module.scss';

const Container = ({ children, ...rest }: ContainerProps) => {
  const containerElement = useRef<HTMLDivElement>();

  useEffect(() => {
    if (containerElement.current) {
      Object
        .keys(rest)
        .forEach((key) =>
          containerElement.current?.style.setProperty(`--${key}`, rest[key as keyof typeof rest]),
        );
    }
  });

  return (
    <div className={styles.container} ref={containerElement}>
      {children}
    </div>
  );
};

export default Container;
